"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = exports.List = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _react = _interopRequireDefault(require("react"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var List = exports.List = function List(props) {
  var children = props.children;
  var comCls = (0, _usePrefixCls.usePrefixCls)('msg__list');
  var items = [];
  _react.default.Children.forEach(children, function (child, index) {
    items.push( /*#__PURE__*/_react.default.cloneElement(child, {
      key: index // eslint-disable-line react/no-array-index-key
    }));
  });
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: comCls
  }, items);
};
var ListItem = exports.ListItem = function ListItem(props) {
  var children = props.children;
  return /*#__PURE__*/_react.default.createElement("li", null, children);
};